import { useState } from 'react'

import { useFilesDownloadAll } from '../../../File'

export function useEmailFilesDownloadAll({
  downloadFilesApi,
  files,
  onSetModal,
}) {
  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    setModal(null)
    onSetModal?.(null)
  }

  const { handleClickDownloadAll } = useFilesDownloadAll({
    downloadFilesApi,
    files,
    onCloseModal: handleCloseModal,
    onSetModal: onSetModal || setModal,
  })

  return {
    handleClickDownloadAll,
    modal,
    setModal,
  }
}
